import request from "@/service";

/* 授课申请列表 */
export function lessonApplyPage(data) {
  return request({
    url: "/sys/lesson/apply/page",
    method: "get",
    params: data
  });
}

export function lessonApplyContact(data) {
  return request({
    url: "/sys/lesson/apply/contact",
    method: "put",
    data
  });
}
